export const Rules = {
  methods: {
    validate: function() {
      let result = true
      this.error = ''
      if (this.rules !== undefined && this.rules !== null) {
        for (let rule of this.rules) {
          result = rule(this.value)
          if (typeof result === 'string') {
            this.error = result
            break
          } else {
            result = true
          }
        }
      }

      if (result === true) {
        this.error = ''
      }
      return result
    },
    reset: function() {
      this.input = this.initialValue
      this.error = ''
    },
    onBlur: function(evt) {
      if (this.validateOnBlur) {
        this.validate()
      }
    }
  },
  mounted() {
    if (this.$refs.input !== undefined) {
      this.$refs.input.addEventListener('blur', this.onBlur)
    }

    if (this.validateImmediately) {
      this.validate()
    }
  },
  beforeDestroy() {
    if (this.$refs.input !== undefined) {
      this.$refs.input.removeEventListener('blur', this.onBlur)
    }
  },
  data() {
    return {
      error: '',
      initialValue: this.value
    }
  },
  watch: {
    value(val) {
      if (this.validateOnInput || (this.validateOnBlur && this.error !== '')) {
        this.validate()
      }
    }
  },
  props: {
    value: {},
    validateOnBlur: {
      type: Boolean,
      default: false
    },
    validateOnInput: {
      type: Boolean,
      default: false
    },
    validateImmediately: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      required: false
    }
  }
}
